import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { TitleBar } from "../components/index.js";
import { getBaseType, getBaseUpgrades } from "../logic/Logic.js";

const Play = ({}) => {
  const [infos, setInfos] = useState({});

  useEffect(() => {
    list();
  }, []);

  const list = async () => {
    const ret = { base: getBaseType(), upgrades: getBaseUpgrades() };
    setInfos(ret);
  };

  return (
    <TitleBar marginLateral={15} showBack={false} titulo={"Play"}>
      <br></br>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>Locattion</th>
            <th>Effect</th>
          </tr>
        </thead>
        <tbody>
          {infos?.base?.map((obj) => {
            return (
              <tr>
                <td>{obj.location}</td>
                <td>{obj.effects}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <br></br>
      <br></br>
      <br></br>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>Upgrade</th>
            <th>Purchase Price</th>
            <th>effect</th>
          </tr>
        </thead>
        <tbody>
          {infos?.upgrades?.map((obj) => {
            return (
              <tr>
                <td>{obj.resource}</td>
                <td>{obj.purchasePrice}</td>
                <td>{obj.effects}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </TitleBar>
  );
};

const mapStateToProps = (state) => ({
  user: state.Reducer.user,
});

const mapDispatchToProps = (dispatch) => ({});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Play);
